import { IPayableSessionData } from "types/payableSession";

export const getPayableSession = (state: any): IPayableSessionData => state.payableSession.payableSession;
